/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Status_ConnectivityInputs */



/**
* | output |
* | --- |
* | "Connectivity" |
*
* @param {Offline_Status_ConnectivityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_status_connectivity = /** @type {((inputs?: Offline_Status_ConnectivityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Status_ConnectivityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectivité")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konnektivität")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connettività")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conectividad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连接性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接続性")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनेक्टिविटी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conectividade")
	return /** @type {LocalizedString} */ ("Connectivity")
});